var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 12 23",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m11.853 6.01c-.121-.121-.281-.201-.455-.201-.054 0-.107.013-.161.027l-5.304 1.313 2.29-6.201c.04-.08.067-.161.067-.241 0-.308-.268-.563-.603-.563h-4.393c-.281 0-.522.174-.589.429l-2.692 11.05c-.04.188.013.388.174.522.107.094.268.147.415.147.054 0 .107 0 .161-.013l5.438-1.353-2.638 10.821c-.067.281.107.563.402.656.067.013.134.027.188.027.241 0 .455-.134.563-.335l7.232-15.496c.094-.201.054-.429-.094-.589",
    fill: "gray"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlash);
export default __webpack_public_path__ + "static/media/flash.811acdc47179f784a6f6f510fc013679.svg";
export { ForwardRef as ReactComponent };